var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('integration-config-tabs',{attrs:{"title-integration-data":'Datos para BSale',"ic":_vm.ic},scopedSlots:_vm._u([{key:"linkingInformation",fn:function(ref){
var visible = ref.visible;
var onUpdateTabs = ref.onUpdateTabs;
return [_c('integration-config-b-sale-linking-information',{attrs:{"ic":_vm.ic,"visible":visible},on:{"onUpdateTabs":onUpdateTabs}})]}},{key:"integrationData",fn:function(ref){
var visible = ref.visible;
return [_c('integration-config-b-sale-integration-data',{attrs:{"ic":_vm.ic,"visible":visible}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }